export default {
  WS_TITLE: {
    ru: "СЛОВА ИЗ СЛОВ",
    en: "WORDS FROM WORDS"
  },
  WS_DESCRIPTION: {
    ru: "Придумайте базовое слово и составляйте новые слова из его букв",
    en: "Make up base word, then create new words from its letters"
  },
  WS_TIMER_INPUT_1: {
    ru: "У каждого игрока есть",
    en: "Every player has"
  },
  WS_TIMER_INPUT_2: {
    ru: "секунд на придумывание слова",
    en: "seconds to make up a word"
  },
  WS_LIVES_INPUT_1: {
    ru: "Игра идет до",
    en: "The game goes up to"
  },
  WS_LIVES_INPUT_2: {
    ru: "таймаутов одного из игроков",
    en: "timeouts of a single player"
  },
  WS_WORDS_LANG_INPUT: {
    ru: "Язык, на котором загадываются слова:",
    en: "Language to make up words in:"
  },
  WS_BASEWORD_INPUT: {
    ru: "Введите базовое слово и нажмите Enter для начала игры:",
    en: "Please type in base word and press Enter key:"
  },
  WS_HINT_DEFINITION: {
    ru: "Наведите курсор на слово, чтобы увидеть его значения",
    en: "Hover pointer over a word to see its meanings"
  },
  WS_HINT_UNDO: {
    ru: "Нажав Ctrl + Z, можно отменить ввод последнего слова",
    en: "Press Ctrl + Z to undo turn and delete last word"
  },
  WS_HINT_PAUSE: {
    ru: "Нажав Alt + P, можно включить или выключить паузу",
    en: "Press Alt + P to enable or disable game pause"
  },
  APP_BASEWORD: {
    ru: "Базовое слово",
    en: "Base word"
  },
  APP_WORD_INPUT: {
    ru: "Ответ игрока...",
    en: "Player's answer..."
  },
  APP_ALERT_TIMEOUT: {
    ru: "Время вышло, ход переходит к игроку",
    en: "Time is out, switching turn to Player"
  },
  APP_ALERT_GAMEOVER_1: {
    ru: "Игра окончена. Игрок",
    en: "Gameover. Player"
  },
  APP_ALERT_GAMEOVER_2: {
    ru: "победил, поздравляем!",
    en: "wins! Congratulations!"
  },
  APP_ALERT_UNDO: {
    ru: "Последнее слово было удалено, ход передан обратно автору слова",
    en: "The last word has been deleted, the turn was passed back to its author"
  },
  APP_ALERT_NOT_NEW_WORD: {
    ru: "Ой, такое слово уже есть в списке",
    en: "Ooops, this word is already in the list"
  },
  APP_ALERT_NO_SUCH_LETTER: {
    ru: "Для этого слова не хватает буквы",
    en: "This word requires one more letter"
  },
  APP_PAUSE_1: {
    ru: "Игра поставлена на паузу. Нажмите",
    en: "The game is on pause. Press"
  },
  APP_PAUSE_2: {
    ru: "еще раз, чтобы продолжить игру",
    en: "again to continue playing"
  },
  WORDS_LOADING_DEF: {
    ru: "Загружаем значения слова...",
    en: "Loading meaning of the word..."
  },
  WORDS_DEF_NOT_FOUND: {
    ru: "Определение слова не найдено",
    en: "Word definition was not found"
  }
}